import { BigFloat } from '@1inch-community/core/math';
import { RateSource, } from '@1inch-community/models';
import { parseAbi } from 'viem';
const abi = parseAbi([
    'function getRate(address srcToken, address dstToken, bool useWrappers) external view returns (uint256 weightedRate)',
]);
export class OneInchOracleBaseRateAdapter {
    constructor(name, factoryContractGetter, supportedChain) {
        this.name = name;
        this.factoryContractGetter = factoryContractGetter;
        this.supportedChain = supportedChain;
    }
    async init(context) {
        this.context = context;
    }
    async getRate(chainId, sourceToken, destinationToken) {
        if (!this.context) {
            return null;
        }
        const client = await this.context.onChain.getClient(chainId);
        const contractAddress = this.factoryContractGetter(chainId);
        const rateRaw = await client.readContract({
            abi,
            address: contractAddress,
            functionName: 'getRate',
            args: [sourceToken.address, destinationToken.address, false],
        });
        const [rate, revertedRate] = normalizeRate(rateRaw, sourceToken, destinationToken);
        return {
            source: RateSource.onChain,
            sourceToken,
            destinationToken,
            rate,
            revertedRate,
            isReverted: false,
        };
    }
    isSupportedChain(chainId) {
        return this.supportedChain.includes(chainId);
    }
}
function normalizeRate(rate, sourceToken, destinationToken) {
    const numerator = BigFloat.from(10 ** sourceToken.decimals);
    const denominator = BigFloat.from(10 ** destinationToken.decimals);
    const rateBigFloat = BigFloat.fromBigInt(rate, 0);
    const price = rateBigFloat.mul(numerator).div(denominator).div(BigFloat.from(1e18));
    return [price, BigFloat.from(1).div(price)];
}
//# sourceMappingURL=one-inch-oracle-base-rate-adapter.js.map